module.exports = __webpack_public_path__ + "images/sort-down-hover-0c01a527.svg";